import { __assign } from "tslib";
import * as React from 'react';
import { joinPaths } from 'retil-history';
import { createMatcher } from '../routerUtils';
import { routeNotFound } from './routeNotFound';
import { routeProvide } from './routeProvide';
var notFoundRouter = routeNotFound();
export function routeByPattern(handlers) {
    var tests = [];
    var patterns = Object.keys(handlers);
    var _loop_1 = function (rawPattern) {
        var handler = handlers[rawPattern];
        var router = routeProvide(typeof handler === 'function'
            ? handler
            : function () { return React.createElement(React.Fragment, null, handler); });
        var matcher = createMatcher(rawPattern);
        tests.push([matcher, router]);
    };
    for (var _i = 0, patterns_1 = patterns; _i < patterns_1.length; _i++) {
        var rawPattern = patterns_1[_i];
        _loop_1(rawPattern);
    }
    return function (request, response) {
        var basename = request.basename, pathname = request.pathname;
        var unmatchedPathname = (pathname.slice(0, basename.length) === basename
            ? pathname.slice(basename.length)
            : pathname) || '/';
        for (var _i = 0, tests_1 = tests; _i < tests_1.length; _i++) {
            var _a = tests_1[_i], matcher = _a[0], router = _a[1];
            var match = matcher(unmatchedPathname);
            if (match) {
                return router(__assign(__assign({}, request), { basename: joinPaths(basename, match.pathname), params: __assign(__assign({}, request.params), match.params) }), response);
            }
        }
        return notFoundRouter(request, response);
    };
}
